import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { Button } from '@deerplusofficial/pos-components';
import { mapState } from '@deerplusofficial/pos-helper';
import actions from '../../actions';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
`;

class MemberActions extends PureComponent {
  onMemberLogout = () => {
    const { resetMember, resetPoints } = this.props;

    resetMember();
    resetPoints();
  };

  render() {
    const {
      member: { name: memberName },
      toggleMemberModal,
    } = this.props;

    return (
      <Container>
        {_.size(memberName) ? (
          <React.Fragment>
            會員：{memberName}
            <Button secondary onClick={this.onMemberLogout}>
              登出
            </Button>
          </React.Fragment>
        ) : (
          <Button primary onClick={toggleMemberModal}>
            登入會員
          </Button>
        )}
      </Container>
    );
  }
}

const {
  modal: { toggle: toggleMemberModal },
  reset: resetMember,
} = actions.member;
const {
  points: { reset: resetPoints },
} = actions.order;

export default connect(
  mapState(['member']),
  { toggleMemberModal, resetMember, resetPoints }
)(MemberActions);



// WEBPACK FOOTER //
// ./src/components/MemberActions/MemberActions.js